module.exports = __webpack_public_path__ + "img/logo.d368f5c2.svg";